import { SVGProps } from '@components/Icon/types';

export const Comments = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(1.5, 2)">
      <path
        d="M4.88614 3.75342C4.48423 3.75342 4.15842 4.07435 4.15842 4.47025C4.15842 4.86614 4.48423 5.18708 4.88614 5.18708H16.1139C16.5158 5.18708 16.8416 4.86614 16.8416 4.47025C16.8416 4.07435 16.5158 3.75342 16.1139 3.75342H4.88614Z"
        fill={fill}
      />
      <path
        d="M4.88614 6.82555C4.48423 6.82555 4.15842 7.14649 4.15842 7.54238C4.15842 7.93828 4.48423 8.25922 4.88614 8.25922H16.1139C16.5158 8.25922 16.8416 7.93828 16.8416 7.54238C16.8416 7.14649 16.5158 6.82555 16.1139 6.82555H4.88614Z"
        fill={fill}
      />
      <path
        d="M4.88614 9.89769C4.48423 9.89769 4.15842 10.2186 4.15842 10.6145C4.15842 11.0104 4.48423 11.3314 4.88614 11.3314H11.1238C11.5257 11.3314 11.8515 11.0104 11.8515 10.6145C11.8515 10.2186 11.5257 9.89769 11.1238 9.89769H4.88614Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.1143C0 1.37976 1.50169 0 3.29061 0H17.7094C19.4983 0 21 1.37976 21 3.1143V12.7524C21 14.4869 19.4978 15.8667 17.7094 15.8667H10.6195L5.83601 19.7214C5.41696 20.0589 4.8735 20.0678 4.43999 19.8656C4.00647 19.6634 3.66919 19.2437 3.66919 18.7103V15.8667H3.29061C1.50169 15.8667 0 14.4869 0 12.7524V3.1143ZM1.43098 3.1143C1.43098 2.18818 2.234 1.40957 3.29061 1.40957H17.7094C18.766 1.40957 19.569 2.18818 19.569 3.1143V7.82409C19.5581 7.89455 19.5581 7.96624 19.569 8.03671V12.7524C19.569 13.6785 18.7653 14.4571 17.7094 14.4571H10.3637C10.1986 14.4573 10.0387 14.5137 9.91096 14.6168L5.10017 18.4942V15.1619C5.10016 14.975 5.02477 14.7957 4.89059 14.6636C4.75642 14.5314 4.57444 14.4571 4.38469 14.4571H3.29061C2.234 14.4571 1.43098 13.6785 1.43098 12.7524V3.1143Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'comments';
